import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>

      <p><strong>Last updated:</strong> September 6, 2026</p>
      
      <section className="privacy-overview">
        <h2>Overview</h2>
        <p>
          This Privacy Policy explains how NeuLogic<span style={tmStyle}>™</span> handles information through this website, software purchases, license activation, and support. NeuLogic does not sell personal information and does not use it for advertising.
        </p>
      </section>
      
      <section className="privacy-datacollection">
        <h2>Desktop Applications</h2>
        <p>
          NeuLogic desktop applications are designed to operate locally and keep application data under the user's control. They do not contain advertising trackers, telemetry, or usage analytics unless a product page explicitly states otherwise. Optional storage locations, including user-selected cloud-synced folders, remain under the user's control.
        </p>
      </section>

      <section className="privacy-purchases">
        <h2>Purchases and License Activation</h2>
        <p>
          Purchases are processed by Stripe. Stripe collects the information required to complete the transaction under its own privacy policy. NeuLogic does not receive or store full payment card numbers.
        </p>
        <p>
          To fulfill a purchase and issue a license, NeuLogic may receive and retain the customer's name and email address, transaction identifiers, purchased product, amount and currency, payment status, license identifier, activation status, and related timestamps.
        </p>
        <p>
          For applications that use machine-bound licensing, the activation service also processes and stores a machine code derived from hashed computer identifiers. The machine code does not contain passwords, application data, vault contents, or readable hardware serial numbers.
        </p>
      </section>
      
      <section className="privacy-website">
        <h2>Website Privacy</h2>
        <p>
          The NeuLogic website does not use advertising trackers or behavioral analytics. Essential browser storage or cookies may be used when required for basic functionality. Third-party services reached through this website, including Stripe, operate under their own privacy policies and may use cookies or similar technologies.
        </p>
      </section>

      <section className="privacy-support">
        <h2>Support Communications</h2>
        <p>
          If you contact NeuLogic, your email address and the information you choose to provide are used to respond to your request, investigate the issue, and maintain relevant support records.
        </p>
      </section>

      <section className="privacy-sharing">
        <h2>Information Sharing</h2>
        <p>
          NeuLogic shares information only with service providers needed to process purchases and operate licensing, when necessary to protect the website or software from abuse, or when required by law. Personal information is not sold or rented.
        </p>
      </section>

      <section className="privacy-retention">
        <h2>Retention and Security</h2>
        <p>
          Purchase and licensing records are retained as needed to issue and validate licenses, provide support, maintain transaction records, prevent misuse, and meet legal obligations. Reasonable technical and administrative safeguards are used to protect retained information, but no storage or transmission method can be guaranteed to be completely secure.
        </p>
      </section>

      <section className="privacy-changes">
        <h2>Changes to This Policy</h2>
        <p>
          This policy may be updated when NeuLogic's website, software, or information practices change. The date above identifies the current version.
        </p>
      </section>
      
      <section className="privacy-contact">
        <h2>Contact</h2>
        <p>
          For questions about this policy or NeuLogic's privacy practices, please contact <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}
